export default function () {
  const confExhibitorTabs = document.querySelectorAll('.winter-conference__exhibitor-tab');
  const confExhibitorLists = document.querySelectorAll('.winter-conference__exhibitor-list');

  if(!confExhibitorTabs || !confExhibitorLists) {
    return;
  }

  const getNextCursorLocation = (index, direction, length) => {
    if (index === 0 && direction === -1) {
      return length - 1;
    }
    if (index === length - 1 && direction === 1) {
      return 0;
    }
    return index + direction;
  };

  const showTabPanel = (panel, button) => {
    button.setAttribute('aria-selected', 'true');
    button.setAttribute('tabindex', '0');
    panel.setAttribute('aria-hidden', 'false');
    panel.removeAttribute('inert');
  };

  const closeTabPanels = (activePanel, activeButton, panels, buttons) => {
    buttons.forEach((button) => {
      if (button.id !== activeButton.id) {
        button.setAttribute('tabindex', '-1');
        button.setAttribute('aria-selected', 'false');
      }
    });

    panels.forEach((panel) => {
      if (panel.id !== activePanel.id) {
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
      }
    });
  };

  const handleTabs = (panel, button, panels, buttons) => {
    if (button.getAttribute('aria-selected') === 'true') return;

    showTabPanel(panel, button);
    closeTabPanels(panel, button, panels, buttons);
  };

  confExhibitorTabs.forEach((button, index) => {
    const panel = document.getElementById(
      button.getAttribute('aria-controls')
    );

    button.addEventListener('click', () => {
      handleTabs(panel, button, confExhibitorLists, confExhibitorTabs);
    });

    button.addEventListener('keydown', (e) => {
      if (e.code !== 'ArrowLeft' && e.code !== 'ArrowRight') {
        return;
      }

      e.preventDefault();

      const direction = e.code === 'ArrowLeft' ? -1 : 1;
      const length = confExhibitorTabs.length;
      const nextCursorLocation = getNextCursorLocation(
        index,
        direction,
        length
      );

      confExhibitorTabs[nextCursorLocation].focus();

      handleTabs(
        confExhibitorLists[nextCursorLocation],
        confExhibitorTabs[nextCursorLocation],
        confExhibitorLists,
        confExhibitorTabs
      );
    });
  });
}
